<template>
	<div>
		<div class="select-field">
			<v-select
				v-model="selectedCountries"
				:options="countryListAsTargetURL"
				:get-option-label="getOptionLabel"
				:get-option-key="(option) => option.CountryId"
				placeholder="Type or select your country"
				multiple
			>
				<template #selected-option-container>
					<div />
				</template>
				<template
					slot="countries"
					slot-scope="countries"
				>
					<img :src="countries.icon">
					{{ countries.country }}
				</template>
			</v-select>
		</div>
		<div class="select-item">
			<div
				v-for="country in selectedCountries"
				:key="country.Country.Id"
				class="select-country"
			>
				<div class="select-title">
					<div class="section-description is-medium is-white-200">
						{{ country.Country.Name }}
					</div>
					<img
						src="@/assets/close.png"
						alt="close"
						@click="removeCountry(country.Country.Id)"
					>
				</div>
				<AppInput
					v-model="country.URL"
					color="underline-light"
					size="full"
					style="width:100%"
					:name="country.Country.Name"
					:rules="{ required: true, url: true }"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'SelectCountryOutput',

	props: {
		value: {
			type: Array,
			required: true,
		},
	},

	computed: {
		...mapGetters([
			'countryList',
		]),

		selectedCountries: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},

		countryListAsTargetURL() {
			const countryListAsTargetURL = this.countryList.map((country) => ({
				Country: country,
				CountryId: country.Id,
				URL: '',
			}));

			return countryListAsTargetURL;
		},
	},

	methods: {
		removeCountry(id) {
			this.selectedCountries = [...this.selectedCountries.filter((country) => country.Country.Id !== id)];
		},
		getOptionLabel(option) {
			return option.Country.Name;
		},
	},
};
</script>

<style lang="scss" scoped>
.select-field {
	margin-top: $gap-2;
}

.select-country {
	background-color: $color-accent-500;
	border-radius: 8px;
	padding: $gap-2;
	margin-top: $gap-2;
}

.select-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
}


/deep/ .v-select {
	color: $color-white;
	font-size: $size-6;
	font-weight: $fontWeight-regular;
	width: 100%;
	height: 32px;

	::placeholder {
		color: $color-accent-400;
		font-size: $size-6;
		font-weight: $fontWeight-regular;
	}
}

/deep/ .vs__dropdown-toggle {
	border: none;

	input, span {
		color: $color-accent-200;
		font-size: $size-6;
		font-weight: $fontWeight-regular;
		padding: 0;
		margin: 0;
	}
}

/deep/ ul.vs__dropdown-menu {
	border-radius: 8px;
	margin-top: $gap-1;

	li {
		color: $color-white;
		font-size: $size-6;
		font-weight: $fontWeight-light;
		padding: $gap-1;
	}
}
</style>
